export const DIGILEFTARROW = `
<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>路径</title>
  <g id="浅色模式" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
    <g id="切图" transform="translate(-317.000000, -183.000000)" stroke="currentColor" stroke-width="3">
      <g id="编组-29" transform="translate(317.000000, 183.000000)">
        <polyline id="路径" transform="translate(10.000000, 10.000000) rotate(-270.000000) translate(-10.000000, -10.000000) " points="4 7 10 13 16 7"></polyline>
      </g>
    </g>
  </g>
</svg>`;

export const DIGIRIGHTARROW = `
<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>路径</title>
  <g id="浅色模式" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
    <g id="切图" transform="translate(-317.000000, -220.000000)" stroke="currentColor" stroke-width="3">
      <g id="编组-29备份" transform="translate(317.000000, 220.000000)">
        <polyline id="路径" transform="translate(10.000000, 10.000000) scale(-1, 1) rotate(-270.000000) translate(-10.000000, -10.000000) " points="4 7 10 13 16 7"></polyline>
      </g>
    </g>
  </g>
</svg>
`;

export const DIGISEARCH = `
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>search icon</title>
  <g id="浅色模式" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.949999988">
    <g id="切图" transform="translate(-416.000000, -67.000000)">
      <g id="编组-11" transform="translate(390.000000, 50.000000)">
        <g id="search-icon" transform="translate(26.000000, 17.000000)">
          <circle id="椭圆形" stroke="currentColor" stroke-width="3" cx="13" cy="13" r="9"></circle>
          <rect id="矩形" fill="currentColor" transform="translate(23.699747, 23.949747) rotate(-45.000000) translate(-23.699747, -23.949747) " x="21.9497475" y="16.9497475" width="3.5" height="14" rx="1"></rect>
        </g>
      </g>
    </g>
  </g>
</svg>`;

export const DIGIUPLOAD = `
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>编组 12</title>
  <g id="浅色模式" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
    <g id="切图" transform="translate(-999.000000, -303.000000)" stroke="currentColor" stroke-width="2.5">
      <g id="编组-34" transform="translate(999.000000, 303.000000)">
        <g id="编组-12" transform="translate(7.000000, 5.000000)">
          <line x1="9" y1="6" x2="9" y2="15" id="路径-5"></line>
          <polyline id="路径-8" stroke-linejoin="round" transform="translate(9.000000, 2.500000) scale(1, -1) translate(-9.000000, -2.500000) " points="3 0 9 5 15 0"></polyline>
          <path d="M0,14 L0,20 C1.3527075e-16,21.1045695 0.8954305,22 2,22 L16,22 C17.1045695,22 18,21.1045695 18,20 L18,14 L18,14" id="路径-10" stroke-linejoin="round"></path>
        </g>
      </g>
    </g>
  </g>
</svg>`;

export const DIGIDOWNLOAD = `
<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>编组 12</title>
  <g id="浅色模式" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
    <g id="切图" transform="translate(-1249.000000, -303.000000)" stroke="currentColor" stroke-width="2.5">
      <g id="编组-36" transform="translate(1249.000000, 303.000000)">
        <g id="编组-12" transform="translate(7.000000, 5.000000)">
          <line x1="9" y1="0" x2="9" y2="9" id="路径-5"></line>
          <polyline id="路径-8" stroke-linejoin="round" points="3 10 9 15 15 10"></polyline>
          <line x1="0" y1="21" x2="18" y2="21" id="路径-10" stroke-linejoin="round"></line>
        </g>
      </g>
    </g>
  </g>
</svg>`;

export const DIGIMENU = `
<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>编组 18</title>
  <g id="浅色模式" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
    <g id="切图" transform="translate(-1402.000000, -149.000000)" stroke="currentColor" stroke-width="2">
      <g id="编组-3" transform="translate(1390.000000, 144.000000)">
        <g id="编组-16" transform="translate(12.000000, 5.000000)">
          <g id="编组-18" transform="translate(5.000000, 5.500000)">
            <line x1="0" y1="0.5" x2="14" y2="0.5" id="路径-3"></line>
            <line x1="0" y1="6.5" x2="14" y2="6.5" id="路径-3备份-2"></line>
            <line x1="0" y1="12.5" x2="14" y2="12.5" id="路径-3备份"></line>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>`;

export const DIGIBOTTOMARROW = `
<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>路径</title>
  <g id="浅色模式" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
    <g id="切图" transform="translate(-1464.000000, -75.000000)" stroke="currentColor" stroke-width="3">
      <g id="编组-26" transform="translate(1464.000000, 75.000000)">
        <polyline id="路径" points="4 8 10 14 16 8"></polyline>
      </g>
    </g>
  </g>
</svg>`;

export const DIGITOPARROW = `
<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <title>路径</title>
  <g id="浅色模式" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
    <g id="切图" transform="translate(-1490.000000, -75.000000)" stroke="currentColor" stroke-width="3">
      <g id="编组-26" transform="translate(1490.000000, 75.000000)">
        <polyline id="路径" transform="translate(10.000000, 10.000000) scale(1, -1) translate(-10.000000, -10.000000) " points="4 7 10 13 16 7"></polyline>
      </g>
    </g>
  </g>
</svg>`;

export const DIGICLOSE = `
<svg viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>search icon</title>
    <g id="浅色模式" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="切图" transform="translate(-1351.000000, -433.000000)">
            <g id="编组-39" transform="translate(1351.000000, 433.000000)">
                <g id="编组-38" transform="translate(1.000000, 1.000000)">
                    <path d="M7,15 L23,15 M15,7 L15,23" id="形状结合" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" transform="translate(15.000000, 15.000000) rotate(-45.000000) translate(-15.000000, -15.000000) "></path>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export const DIGIMAIL = `
<svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>编组 8</title>
    <g id="工厂配色" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="切图" transform="translate(-734.000000, -159.000000)" stroke="currentColor" stroke-width="2">
            <g id="编组-9" transform="translate(428.000000, 132.000000)">
                <g id="编组-8" transform="translate(306.000000, 27.000000)">
                    <g id="编组-14" transform="translate(1.000000, 3.000000)">
                        <rect id="矩形" x="1" y="1" width="20" height="16" rx="2"></rect>
                        <path d="M2.44444444,3.375 L11,11.25 L19.5555556,3.375" id="路径-4"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;


export const DIGICALENDAR = `
<svg viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>编组 8</title>
    <g id="工厂配色" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="切图" transform="translate(-1080.000000, -375.000000)">
            <g id="编组-11" transform="translate(428.000000, 362.000000)">
                <g id="编组-34" transform="translate(652.000000, 13.000000)">
                    <g id="编组-8" transform="translate(2.000000, 3.000000)">
                        <rect id="矩形" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" x="0" y="0" width="26" height="24" rx="4"></rect>
                        <line x1="0" y1="5" x2="26" y2="5" id="路径-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line>
                        <circle id="椭圆形" fill="currentColor" cx="9" cy="11" r="2"></circle>
                        <circle id="椭圆形备份-2" fill="currentColor" cx="9" cy="17" r="2"></circle>
                        <circle id="椭圆形备份" fill="currentColor cx="17" cy="11" r="2"></circle>
                        <circle id="椭圆形备份-3" fill="currentColor" cx="17" cy="17" r="2"></circle>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export const DIGIDOUBLECIRCLE = `
<svg viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>编组 18备份</title>
    <g id="工厂配色" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g id="切图" transform="translate(-1391.000000, -161.000000)" stroke="currentColor" stroke-width="2">
            <g id="编组-26" transform="translate(1391.000000, 161.000000)">
                <g id="编组-19" transform="translate(2.000000, 2.000000)">
                    <circle id="椭圆形" cx="9" cy="9" r="3"></circle>
                    <circle id="椭圆形" cx="9" cy="9" r="9"></circle>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export const DIGILONGARROW = `
<svg viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>编组 4</title>
    <g id="工厂配色" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g id="切图" transform="translate(-1221.000000, -162.000000)" stroke="currentColor" stroke-width="3">
            <g id="编组-33" transform="translate(1028.000000, 148.000000)">
                <g id="编组-25" transform="translate(193.000000, 14.000000)">
                    <g id="编组-4" transform="translate(2.147250, 4.000000)">
                        <polyline id="路径" transform="translate(11.852750, 6.000000) rotate(-90.000000) translate(-11.852750, -6.000000) " points="5.8527504 3 11.8527504 9 17.8527504 3"></polyline>
                        <line x1="11.8527504" y1="6" x2="-1.42108547e-14" y2="6" id="路径-5"></line>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export const DIGIBIGPLUS = `
<svg viewBox="64 64 896 896" focusable="false"><defs><style /></defs><path d="M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z" /><path d="M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z" /></svg>`;

export const DIGISQUAREPLUS = `
<svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>编组 7</title>
    <g id="工厂配色" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="切图" transform="translate(-1631.000000, -395.000000)" stroke="currentColor" stroke-width="2.5">
            <g id="编组-12备份" transform="translate(1602.000000, 380.000000)">
                <g id="编组-36" transform="translate(29.000000, 15.000000)">
                    <g id="编组-7" transform="translate(2.000000, 2.000000)">
                        <rect id="矩形" x="0" y="0" width="30" height="30" rx="6"></rect>
                        <path d="M8,15 L22,15 M15,8 L15,22" id="形状结合" transform="translate(15.000000, 15.000000) rotate(-90.000000) translate(-15.000000, -15.000000) "></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export const DIGIBOSCHLOGO = `
<svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 96.4 96.4" style="enable-background:new 0 0 96.4 96.4;" xml:space="preserve">
<path d="M48.2,0C21.6,0,0,21.6,0,48.2s21.6,48.2,48.2,48.2s48.2-21.6,48.2-48.2S74.8,0,48.2,0z M48.2,91.9
	c-24.1,0-43.7-19.6-43.7-43.7S24.1,4.5,48.2,4.5s43.7,19.6,43.7,43.7l0,0C91.9,72.3,72.3,91.9,48.2,91.9z"/>
<path d="M-85.7-47h18.3c3.6,0,6.5,0.5,8.7,1.5c2.2,1,4.1,2.4,5.5,4.2c1.4,1.8,2.5,4,3.2,6.4c0.7,2.4,1,5,1,7.7
	c0,4.3-0.5,7.6-1.5,9.9s-2.3,4.3-4,5.9c-1.7,1.6-3.6,2.6-5.5,3.2c-2.7,0.7-5.1,1.1-7.3,1.1h-18.3V-47z"/>
<path d="M-68.3-41.1h9.3v16.3c0,3.4-0.3,6-0.9,7.8c-0.6,1.8-1.8,3.3-3.7,4.5c-1.8,1.2-4.2,1.9-7,1.9c-3,0-5.4-0.4-7-1.2
	s-2.9-2-3.8-3.6s-1.4-3.5-1.6-5.8l8.8-1.2c0,1.3,0.1,2.3,0.3,2.9c0.2,0.6,0.6,1.2,1.1,1.6c0.4,0.3,0.9,0.4,1.5,0.4
	c1,0,1.8-0.4,2.3-1.2c0.5-0.8,0.7-2.1,0.7-3.9V-41.1z"/>
<path d="M-51.3,21.5c-0.7-2.4-1.7-4.6-3.2-6.4c-1.4-1.8-3.3-3.2-5.5-4.2c-2.2-1-5.1-1.5-8.7-1.5H-87v39.8h18.3
	c2.2,0,4.6-0.4,7.3-1.1c2-0.5,3.8-1.6,5.5-3.2c1.7-1.6,3.1-3.5,4-5.9c1-2.3,1.5-5.6,1.5-9.9C-50.4,26.5-50.7,23.9-51.3,21.5z
	 M-60.3,31.6c0,3.4-0.3,6-0.9,7.8c-0.6,1.8-1.8,3.3-3.7,4.5c-1.8,1.2-4.2,1.9-7,1.9c-3,0-5.4-0.4-7-1.2c-1.7-0.8-2.9-2-3.8-3.6
	c-0.9-1.6-1.4-3.5-1.6-5.8l8.8-1.2c0,1.3,0.1,2.3,0.3,2.9c0.2,0.6,0.6,1.2,1.1,1.6c0.4,0.3,0.9,0.4,1.5,0.4c1,0,1.8-0.4,2.3-1.2
	c0.5-0.8,0.7-2.1,0.7-3.9V15.3h9.3V31.6z"/>
<g>
	<path d="M-77.9-77.4c0,0,9.8,0,9.8,0c5.3,0,9.6-3,11.4-8c0.7-1.9,1-4.2,1-7c0-6-1.5-12.8-7.6-15.3c-3.6-1.5-7.7-1.2-11.6-1.2
		c-1.7,0-3,1.3-3,3v7.7c0,1.7-1.4,3-3,3l-4.9,0c-1.7,0-3-1.4-3-3V-115c0-1.7,1.3-3,3-3h18.5c3.2,0,6.2,0.5,9,1.5
		c2.8,1,5.2,2.6,7.2,4.6c2,2,3.6,4.6,4.7,7.7c1.1,3.1,1.7,6.7,1.7,10.8c0,3.6-0.5,7-1.4,10c-0.9,3.1-2.3,5.7-4.2,8
		c-1.9,2.2-4.2,4-7,5.3c-2.8,1.3-6.1,1.9-9.9,1.9h-7.5c-1.7,0-3-1.3-3-3V-77.4"/>
</g>
<circle cx="-83.5" cy="-86.6" r="6.5"/>
<g>
	<path d="M77.7,32.2C73,23.1,64.4,17.7,53.6,17.1c-0.1,0-2.2,0-27.6,0h-1.6v30.3l15-0.1V31.6c0,0,15.3-1,19,0.6
		c7.2,3,8.8,12.6,7.2,20.2c-1.2,6.2-5.3,12.8-13,12.8h-9.8v14.1h10.7c9.7,0,17.2-4.2,22.4-12.5C82.5,56.3,83.2,42.8,77.7,32.2z"/>
	<path d="M53.6,79.8H42.3V64.6h10.3c7.4,0,11.3-6.4,12.5-12.3c1.5-7.4,0-16.8-6.9-19.6C55.1,31.3,42.7,32,40,32.1v15.7l-16.1,0.2
		V16.6H26c27.6,0,27.6,0,27.7,0c11,0.6,19.7,6.1,24.5,15.4l0,0c5.6,10.7,4.9,24.5-1.7,35C71.1,75.5,63.4,79.8,53.6,79.8z M43.4,78.7
		h10.2c9.5,0,16.9-4.1,22-12.3c6.4-10.2,7.1-23.5,1.7-33.9c-4.7-9-13.1-14.3-23.6-14.8c-0.1,0-2.8,0-27.6,0h-1v29.2l14-0.1V31.1
		l0.5,0c0.6,0,15.5-1,19.2,0.6c7.4,3.1,9.1,13,7.6,20.8c-1.3,6.4-5.5,13.2-13.6,13.2h-9.3V78.7z"/>
</g>
<circle cx="32.5" cy="59.5" r="7.1"/>
</svg>
`;

export const DIGIBOSCHBLACKLOGO = `
<svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 96.4 96.4" style="enable-background:new 0 0 96.4 96.4;" xml:space="preserve">
<style type="text/css">
	.st0{fill:none;}
</style>
<rect x="-63.6" y="-63.6" class="st0" width="560.2" height="223.6"/>
<path d="M48.2,0C21.6,0,0,21.6,0,48.2s21.6,48.2,48.2,48.2s48.2-21.6,48.2-48.2C96.4,21.6,74.8,0,48.2,0z M48.2,91.9
	c-24.1,0-43.7-19.6-43.7-43.7S24.1,4.5,48.2,4.5s43.7,19.6,43.7,43.7v0C91.9,72.3,72.3,91.9,48.2,91.9z"/>
<path d="M68.1,18.1h-3.3v16.5H31.7V18.1h-3.4c-16.6,11-21.2,33.3-10.2,50c2.7,4.1,6.2,7.6,10.2,10.2h3.4V61.8h33.1v16.5h3.3
	c16.6-11,21.2-33.3,10.2-50C75.7,24.3,72.2,20.8,68.1,18.1z M27.1,71.8c-13-11.6-14.2-31.5-2.6-44.6c0.8-0.9,1.7-1.8,2.6-2.6V71.8z
	 M64.8,57.2H31.7V39.1h33.1V57.2z M69.3,71.7v-10l0,0V34.6l0,0v-10c13,11.7,14.1,31.7,2.4,44.7C70.9,70.1,70.1,70.9,69.3,71.7z"/>
</svg>`;
